export const BUFFER_MARGIN = 400;
export const MARGIN_BETWEEN_BRANCH_NODES = 20;
export const LEFT_CANVAS_PADDING = 500;
export const BOTTOM_CANVAS_PADDING = 200;
export const CARD_CONTENT_PADDING = 24;
export const MAX_CONTENT_HEIGHT = 220;
export const EMPTY_CARD_CONTENT_HEIGHT = 50;
export const DEFAULT_EMPTY_CARD_CONTENT_HEIGHT = 60;
export const NUM_OF_NODES_BEFORE_VIRTUAL_RENDERING = 5;
export const CARD_WIDTH = 350;
export const CARD_HEIGHT = 192;
export const EMBEDDED_CARD_WIDTH = CARD_WIDTH - 41;
export const EMBEDDED_CARD_HEIGHT = 212;
export const CARD_WIDTH_PADDING = 20;
export const DEFAULT_CARD_HEIGHT = 110;
export const SINGLE_CONNECTOR_HEIGHT = 72;
export const BRANCH_CONNECTOR_TOP_HEIGHT = 8;
export const BRANCH_CONNECTOR_BOTTOM_HEIGHT = 140;
export const BRANCH_CONNECTOR_HEIGHT = BRANCH_CONNECTOR_TOP_HEIGHT + BRANCH_CONNECTOR_BOTTOM_HEIGHT; // Entire height from base of previous node to top of next one
export const MIN_CARD_HEIGHT = 104;
export const SET_CARD_HEADER_HEIGHT = 35;
export const DETAIL_MIN_ZOOM_LEVEL = 0.6;
export const MINIMAP_CONTAINER_WIDTH = 600;